
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import CourseCard from '../CourseCard/index.vue'
import EmptyStatus from '@xt/www/components/emptyStatus/index.vue'
import { EnumEmptyStatus } from '@xt/client/utils/empty-status/index'
import { Observer } from 'mobx-vue'
import type { EmblaCarouselType, EmblaOptionsType } from 'embla-carousel'
import EmblaCarousel from 'embla-carousel'
import { Bind } from 'lodash-decorators'

const OPTIONS: EmblaOptionsType = { loop: false, duration: 30 }

@Observer
@Component({
  components: {
    CourseCard,
    EmptyStatus
  }
})
export default class ProgressCourse extends Vue {
  current: number = 0
  prevBtnHover: boolean = false
  nextBtnHover: boolean = false

  @Ref()
  dotContainer: HTMLElement

  emblaApi: EmblaCarouselType

  @Ref()
  swiper: HTMLDivElement

  get EnumEmptyStatus() {
    return EnumEmptyStatus
  }

  get PageStore() {
    return this.$store.$myV2.Center
  }

  @Bind()
  handleScroll(emblaApi: EmblaCarouselType) {
    const idx = emblaApi.selectedScrollSnap()
    this.current = idx
    this.scrollDotToView(idx)
  }

  onPrev() {
    if (!this.emblaApi) return

    this.emblaApi.scrollPrev()
  }

  onNext() {
    if (!this.emblaApi) return

    this.emblaApi.scrollNext()
  }

  onScrollTo(idx: number) {
    if (!this.emblaApi) return

    this.emblaApi.scrollTo(idx)
  }

  // 指示点超长自动滚动到中间
  scrollDotToView(idx: number) {
    if (!this.dotContainer) return

    const activeDot = this.dotContainer.children[idx]

    if (!activeDot) return

    // 浏览器原生 API：自动滚动到视野内（居中）
    activeDot.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'nearest'
    })
  }

  handleToProduct(id: number) {
    window.open(`/commodity/${id.toString()}`)
  }

  created(): void {}

  mounted(): void {
    if (!this.swiper) return

    this.emblaApi = EmblaCarousel(this.swiper, OPTIONS)

    this.emblaApi.on('select', this.handleScroll)
  }

  updated(): void {}

  destroyed(): void {}
}
